import { render, staticRenderFns } from "./polymers-dealer.vue?vue&type=template&id=fc83dc48&scoped=true"
import script from "./polymers-dealer.vue?vue&type=script&lang=js"
export * from "./polymers-dealer.vue?vue&type=script&lang=js"
import style0 from "./polymers-dealer.vue?vue&type=style&index=0&id=fc83dc48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc83dc48",
  null
  
)

export default component.exports